import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
import CancellationExperience from './CancellationExperience';
import CancellationAccommodation from './CancellationAccommodation';
import CancellationAccommodationEjunifer from './CancellationAccommodationEjunifer';
import InvoiceTableHeader from './InvoiceTableHeader'
import { padding } from '@mui/system';

const borderColor = '#F5F5F5'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#F5F5F5',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontStyle: 'bold',
        height: 'auto',
        fontStyle: 'bold',
        overflowY: 'scroll',
        justifyContent: 'center',
        fontSize:10
    },
    headerchild:{
        borderWidth: 1,
        borderColor: '#000',
        marginBottom: 10,
        border: 1,
    },
    offer:{
      backgroundColor: 'green',
    },
 
    description: {
        width: '30%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 5,
        paddingTop: 7,
        height: 'auto',
        lineHeight:1.5,
    },
    details: {
      width: '30%',
      textAlign: 'left',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      paddingLeft: 5,
      paddingTop: 7,
      height: 'auto',
      lineHeight:1.5,
  },
    service_date: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'left',
        paddingLeft: 5,
        paddingTop: 7,
        height: 'auto',
        lineHeight:1.5,
    },
    rate: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      textAlign: 'right',
      paddingRight: 5,
      paddingTop: 7,
      height: 'auto',
      lineHeight:1.5,
  },

  dayplanheader: {
    background: '#f9f9f9',
    minHeight: '20px',
   // margin: '10px 0px 0 0px',
    display: 'flex',
    flexDirection: 'row',
    position: 'sticky',
    borderColor: '#ff8e4a',
    marginBottom: 10,
},

dayplanTitle: {
  fontSize: '9px',
  color: '#ffffff',
  fontWeight: 900,
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  maxWidth: '250',
  backgroundColor: '#ff8e4a',
  borderRadius: '6px 6px/0px 100% 100% 0px'
},

hotelRowHotelTag: {
  fontSize: '10px',
  color: '#000',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  backgroundColor: '#ffe6a7',
  display: 'flex',
  alignItems: 'center',
  padding: '5px',
  marginBottom: '10px',
  maxWidth: '100'
},
  cancellationpolicy:{
    borderBottomColor: '#F5F5F5',
    borderBottomWidth: 1,
  },
  redText: {
    borderColor: '#eb2026',
    color: '#eb2026',
    padding:4
  },
  spriteNew: {
    background: 'none',
    backgroundColor: '#eb2026',
    color:'#fff',
    borderRadius: 10,
    width: 'auto',
    height: 'auto',
    fontSize: 7,
    padding:5
},
linecutting:{
  textDecoration: 'line-through',
  fontSize: 9,
  fontWeight: 900,
},
fontweightMain:{
  fontWeight: 900,
  fontSize: 10,
  lineBreak:'normal',
  marginBottom: 1,
 // paddingTop:5,
  marginTop:5,
},
fontweightMainNormal:{
  fontWeight: 900,
  fontSize: 10,
},
offerSave:{
  marginTop:1
}
  });

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      const GuesttravellerCount = JSON.parse(item.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Adults,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Children&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.infantCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Infant,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.youthCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Youth,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.seniorCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Senior,&nbsp;
                </>
              )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.groupCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Travelers,&nbsp;
                </>
              )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      }
    }
  };

  const getAmountPrice = (item) => {
 
         if(item?.totalAmount==item?.totalamountincluded){
           return (
             <Text style={styles.fontweightMainNormal}><b>€ {parseFloat(item?.totalamountincluded).toFixed(2)}</b></Text>
           );
         }else{
           return (
             <>
               
               <Text style={styles.linecutting}>
               
               € {parseFloat(item?.totalAmount).toFixed(2)}{'\n'}
               </Text>
              
               <Text style={styles.offerSave}>
                 <Text style={styles.redText}>
                   <Text>Save &nbsp;</Text>
                   <Text>
                     € 
                     {parseFloat(item?.percentageAm).toFixed(2)}{" "}
                   </Text>
                 </Text>
                 <Text style={styles.spriteNew}>
                   &nbsp; {item?.percentage}{" "}%
                 </Text>
                
               </Text>
               <Text style={styles.fontweightMain}> 
              <b> {'\n'} € 
              {parseFloat(item?.totalamountincluded).toFixed(2)}</b>
               </Text>
             </>
           );
         }
      
     };

     const getAccomodationDetails = (item) => {
      // console.log(item.junifer);
      return(<>
     {item?.junifer != null ? (
      <>
        {item?.junifer?.HotelRooms?.HotelRoom
          .length > 0 ? (
        
          <>
            {" "}
            {item?.junifer?.HotelRooms?.HotelRoom.map(
              (roomname, index) => (
                <>
                  <Text>
                      {roomname?.attributes?.Units}{" "}
                      X {roomname?.Name} (
                      {item?.junifer?.Board})
                  </Text>
                </>
              )
            )}
          </>
        ) : (
          <>
            <Text>
              
                {
                  item?.junifer?.HotelRooms
                    .HotelRoom.attributes.Units
                }{" "}
                X{" "}
                {
                  item.junifer.HotelRooms
                    .HotelRoom.Name
                }{" "}
                ({item.junifer.Board})
              
            </Text>
          </>
        )}
      </>
    ) : (
      <>
        {item?.typedata == "multiple" ? (
          <>
            {item?.cartvalue.map(
              (cartitem, indexcart) => (
                <>
                  <Text>
                      {cartitem?.roomCounter} X{" "}
                      {cartitem?.name}
                  </Text>
                </>
              )
            )}
          </>
        ) : (
          <>
            <Text>
                1 X {item?.roomname}
            </Text>
          </>
        )}
      </>
    )}
    </>
      );
        };
const InvoiceTableRow = ({items}) => {

  var items1 = (JSON.stringify(items));
    var items2 = JSON.parse(items1);
    var items3 = JSON.parse(items2);
   // console.log(items3);
  const rows =  items3?.dayPlan!=null && items3?.dayPlan.map((sequenceDate, indexData) => { 
    let Accomodationinput = items3?.itineraryDetails.find(
      (y) =>
        moment(y.range[0].startDate).format("Y-MM-DD") <=
          moment(sequenceDate).format("Y-MM-DD") &&
        moment(y.range[0].endDate).format("Y-MM-DD") >
          moment(sequenceDate).format("Y-MM-DD")
    );
   // console.log(sequenceDate);
    let itineraryinput = items3?.itineraryDetails.find(
      (yy) =>
        moment(yy.range[0].startDate).format("Y-MM-DD") <=
          moment(sequenceDate).format("Y-MM-DD") &&
        moment(yy.range[0].endDate).format("Y-MM-DD") >=
          moment(sequenceDate).format("Y-MM-DD")
    );
       
      return( <View>
          <View style={styles.dayplanheader}><Text style={styles.dayplanTitle}>Day {indexData + 1} - {moment(sequenceDate).format("DD MMM Y")}-  {items3.selectedStartLocation !='' && indexData == 0 &&(<> {items3.selectedStartLocation} - </>)} {itineraryinput?.Location.label} {Accomodationinput?.Location.label != itineraryinput?.Location.label &&(<> - {Accomodationinput?.Location.label}</>)} {items3?.selectedEndLocation !='' &&  items3?.dayPlan.length == indexData+1 &&(<> {items3?.selectedEndLocation}</>)}</Text></View>
         { items3.child!=null && items3.child.map((item) =>{
          let date1 = new Date(item.startDate);
          let date2 = new Date(item.endDate);
          let dateselected = new Date(item.dateselected);

          let timeDiff = Math.abs(date1.getTime() - date2.getTime());
          let numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));
          let DataValue = '';
       
         if (item.profileactivity != "Accommodations") {
 
          if (
            moment(dateselected).format("Y-MM-DD") ===
            moment(sequenceDate).format("Y-MM-DD")
          ) {
           
            return(<View style={styles.headerchild}>
         <View style={styles.hotelRowHotelTag}><Text>{item.profileactivity}</Text></View>
          <InvoiceTableHeader /> 
        <View style={styles.row} key={item.booking_refrence_id}>
        
              <Text style={styles.description}> {item.profileactivity == "Accommodations" ?item.propertyName:item.tourName}</Text>
              <Text style={styles.details}> {item.profileactivity == "Accommodations" ?item&&(getAccomodationDetails(item)):item.tourOption} ({getTotalNumber(item)})</Text>
              <Text style={styles.service_date}>{item.profileactivity == "Accommodations" ? moment(item.startDate).format("D MMM Y") +' - '+moment(item.endDate).format("D MMM Y"):moment(item.dateselected).format("D MMM Y")}</Text>
            <Text style={styles.rate}>{getAmountPrice(item)}</Text>
          </View >
         
          {item?.profileactivity != "Accommodations"? (<CancellationExperience invoice={item} />):(item?.accommodationtype == 'ejunifer'?<CancellationAccommodationEjunifer invoice={item} />:<CancellationAccommodation invoice={item} />)} 
          </View>);
          }}else{

            if (
              moment(item.startDate).format("Y-MM-DD") <=
                moment(sequenceDate).format("Y-MM-DD") &&
              moment(item.endDate).format("Y-MM-DD") >
                moment(sequenceDate).format("Y-MM-DD")
            ) {
                return(<View style={styles.headerchild}>
              <View style={styles.hotelRowHotelTag}><Text>{item.profileactivity}</Text></View>
               <InvoiceTableHeader /> 
             <View style={styles.row} key={item.booking_refrence_id}>
             
                   <Text style={styles.description}> {item.profileactivity == "Accommodations" ?item.propertyName:item.tourName}</Text>
                   <Text style={styles.details}> {item.profileactivity == "Accommodations" ?item&&(getAccomodationDetails(item)):item.tourOption} ({getTotalNumber(item)})</Text>
                   <Text style={styles.service_date}>{item.profileactivity == "Accommodations" ? moment(item.startDate).format("D MMM Y") +' - '+moment(item.endDate).format("D MMM Y"):moment(item.dateselected).format("D MMM Y")}</Text>
                 <Text style={styles.rate}>{getAmountPrice(item)}</Text>
               </View >
              
               {item?.profileactivity != "Accommodations"? (<CancellationExperience invoice={item} />):(item?.accommodationtype == 'ejunifer'?<CancellationAccommodationEjunifer invoice={item} />:<CancellationAccommodation invoice={item} />)} 
               </View>);
            }
          }  } )}
            </View>);
  })
 // console.log(rows);
  return (<Fragment>{rows}</Fragment> )
};
export default InvoiceTableRow